module.exports = __webpack_public_path__ + "img/avatar.d8fb9c47.png";